import { combineReducers } from "redux";
import user from "./user";
import register from "./register";
import cache from "./cache";

export const root =  combineReducers({ user, register, cache });